<template>
	<div class="timer" >

		<div class="timer">
			<div class="timer__iconHolder">
				<i class="fa fa-clock-o" aria-hidden="true"></i>
			</div>
			<div class="timer__bar">
				<div class="timer__bar__filler" :style="style"></div>
			</div>
		</div>
		<!--
		<img class="timer__icon" :src="image"/>
		<div class="timer__bar">
			<div class="timer__filler"/>
		</div>
		<div style="clear: both"/>-->
	</div>

</template>

<script>
	export default {

		props: [
			'image',
			'percentage',
		],

		data(){
			return{
				usedPercentage: 0
			}
		},

		mounted(){
			this.usedPercentage = this.percentage;
		},

		watch:{
			percentage : function (val)
			{
				this.usedPercentage = val;
				$( ".timer__filler" ).css("width" , val+"%");
			},
		},

		computed: {
			style(){

				let percentage = this.usedPercentage + "%";
				return{width: percentage};
			}
		},

		methods:{
		},

	}
</script>


// WEBPACK FOOTER //
// src/components/Timer.vue